import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconPlay = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M18.21 10.906L10.29 4.93c-.673-.516-1.392-.586-2.157-.211-.75.36-1.125.96-1.125 1.804v11.954c0 .843.375 1.453 1.125 1.828.765.36 1.484.28 2.156-.235l7.922-5.976c.531-.406.797-.938.797-1.594 0-.656-.266-1.188-.797-1.594z" }),
});

export { IconPlay };
